import { jsx } from 'react/jsx-runtime';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { clamp } from '../../../utils/clamp.es.js';

const root = "_root_safhj_1";
const progress = "_progress_safhj_9";
const styles = {
	root: root,
	progress: progress
};

const ProgressBar = ({ max = 1, min = 0, color = "UiPrimaryStronger", value }) => {
  const clampedValue = clamp(value, min, max);
  const range = max - min;
  const decimal = (clampedValue - min) / range;
  const width = `${decimal * 100}%`;
  return jsx("div", { className: styles.root, "data-zds": true, children: jsx("div", { className: styles.progress, "data-testid": "progress", "data-zds": true, style: {
    "--progress-bar-width": width,
    "--progress-bar-color": Colors[color]
  } }) });
};

export { ProgressBar };
//# sourceMappingURL=ProgressBar.es.js.map
